/**
 * Socket.IO factory for the `/notifications` namespace. Mirrors the inbox
 * socket client: JWT in the handshake `auth.token`, websocket-only, auto
 * reconnection. The caller connects after attaching listeners.
 */
import { io, type Socket } from 'socket.io-client';

export type NotificationsSocket = Socket;

const DEFAULT_BASE_URL = (import.meta.env.VITE_API_URL ?? 'http://localhost:3000') as string;

export function createNotificationsSocket(token: string): NotificationsSocket {
    return io(`${DEFAULT_BASE_URL}/notifications`, {
        autoConnect: false,
        reconnection: true,
        reconnectionAttempts: Infinity,
        reconnectionDelay: 500,
        reconnectionDelayMax: 5_000,
        timeout: 10_000,
        transports: ['websocket'],
        auth: { token },
        withCredentials: true,
    });
}
